import React from "react";
import {
    Grid,
} from '@deere/fuel-react';
import {RatingsCampaignCard} from "./RatingsCampaignCard";
import {RatingsSpendCard} from "./RatingsSpendCard";
import {RatingsPastPerformanceCard} from "./RatingsPastPerformanceCard";

export const RatingsSummary = ({isSupplier, pastPerformanceRating, supplierNumber, fiscalYear, functionalArea, spendData, onPastPerformanceOverview}) => {
    return (
        <Grid container>
            <RatingsPastPerformanceCard 
                pastPerformanceRating={pastPerformanceRating} 
                supplierNumber={supplierNumber}
                functionalArea={functionalArea}
                onPastPerformanceOverview={onPastPerformanceOverview}
            />
            <RatingsSpendCard supplierNumber={supplierNumber} spendData={spendData}/>
            <RatingsCampaignCard isSupplier={isSupplier}/>
        </Grid>
    )
}